import Repository from "./Repository";

const ADD_MENU = "add";
const DELETE_MENU = "delete";
const UPDATE_MENU = "update";
const GET_MENU = "get";
const COMBINEDMENU = "combinedMenuData";

export default {
  getAllMenu(payload) {
    return Repository.post(transformRoute(GET_MENU),payload);
  },
  addOneMenu(payload) {
    return Repository.post(transformRoute(ADD_MENU), payload);
  },
  editOneMenu(payload) {
    return Repository.post(transformRoute(UPDATE_MENU), payload);
  },
  deleteOneMenu(payload) {
    return Repository.post(transformRoute(DELETE_MENU), payload);
  },
  combinedMenuData(payload) {
    return Repository.post(transformRoute(COMBINEDMENU), payload);
  },
};

const transformRoute = (route) => {
  return `/menu/twoHierarchyMenu/${route}`;
};
